import styles from './snackbar.module.scss';
import MaterialSnackbar from '@mui/material/Snackbar';
import MaterialSnackbarContent from '@mui/material/SnackbarContent';

/* eslint-disable-next-line */
export interface SnackbarProps {
  action?: any,
  anchorOrigin?:
  {
    horizontal: 'center' | 'left' | 'right',
    vertical: 'bottom' | 'top'
  },
  autoHideDuration?: number;
  children?: any,
  // classes?: object,
  // ClickAwayListenerProps?: object,
  // ContentProps?: object,
  // disableWindowBlurListener?: boolean,
  key?: any;
  message?: any;
  onClose?: (event: any, reason: string) => void;
  open?: boolean;
  // resumeHideDuration?: number,
  // sx?: any,
  TransitionComponent?: any,
  // transitionDuration?: number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object
}

export interface SnackbarContentProps {
  action?: any;
  // classes?: object,
  message?: any;
  role?: string,
  // sx?: any
}

export function Snackbar(props: SnackbarProps) {
  return (
    <MaterialSnackbar
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={props.TransitionComponent}
      message={props.message}
      key={props.key}
      autoHideDuration={props.autoHideDuration}
      anchorOrigin={props.anchorOrigin}
      action={props.action}>
      {props.children}
    </MaterialSnackbar>
  );
}

export function SnackbarContent(props: SnackbarContentProps) {
  return (
    <MaterialSnackbarContent
      message={props.message}
      action={props.action}
      role={props.role}
    />
  );
}

export default Snackbar;